<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :label-width="$device.mobile ? `` : `120px`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <PeriodFormItem v-model="searchForm" />
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('StatisticsMenuSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <!--			<el-button v-if="checkAuthActionAccess('StatisticsMenuSearch')" :size="size"  @click="chart" icon="el-icon-picture-outline" >{{ $t('그래프 보기') }}</el-button>-->
      <SalesBasisInfo basis="list" class="basis-inline" />
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')">
      <!--              :summary-method="getSummaries" show-summary="true" -->

      <el-table-column label="총 합계">
        <el-table-column
          :label="$t('상품명')"
          prop="type_name"
          min-width="100"
          sortable
          align="center"></el-table-column>
      </el-table-column>
      <el-table-column :label="summaries[1].toString()">
        <el-table-column
          :label="$t('합계')"
          prop="price"
          min-width="100"
          sortable
          align="right"
          :formatter="mainVue.formatterNum"></el-table-column>
      </el-table-column>
      <el-table-column :label="summaries[2].toString()">
        <el-table-column
          :label="$t('총수량')"
          prop="count"
          min-width="100"
          sortable
          align="right"
          :formatter="mainVue.formatterNum"></el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import PeriodFormItem from '@/components/statistics/PeriodFormItem.vue'
import SalesBasisInfo from '@/components/SalesBasisInfo.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { statisticsAxisRange } from '@/utils/periodFilter'

export default {
  mixins: [mainVueMixin],

  components: { PeriodFormItem, SalesBasisInfo },

  data: function () {
    var data = initData()
    data.url = '/statistics/menu'
    data.searchForm = this.initSearchForm()

    data.summaries = ['총 합계', 0, 0]

    // data.dialogChartVisible = false;

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    // 분류 선택 이벤트 — 고른 축의 기본 기간은 `utils/periodFilter` 의 `statisticsAxisRange` 한 곳이 셈한다(KST 달력)
    'searchForm.dateSearchTp': function (newVal) {
      if (this.$t('일별') == newVal) {
        this.searchForm.dateSearchTpVal = 'DAY'
      } else if (this.$t('월별') == newVal) {
        this.searchForm.dateSearchTpVal = 'MONTH'
      } else if (this.$t('년별') == newVal) {
        this.searchForm.dateSearchTpVal = 'YEAR'
      }
      Object.assign(this.searchForm, statisticsAxisRange(this.searchForm.dateSearchTpVal, Date.now()))
      this.search()
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        dateSearchTp: this.$t('일별'),
        // dateSearchTpVal: 't',
        dateSearchTpVal: 'DAY',
        // seDt: [util.getDate('yyyy-MM-dd HH:mm', util.dateAdd('HOUR ', -2, new Date())), util.getNow('yyyy-MM-dd HH:mm')], // 시간별
        // seDt: [util.getDate('yyyy-MM-dd', util.dateAdd('w ', -1, new Date())), util.getNow('yyyy-MM-dd')], // 일별 - 일주일
        seDt: [util.getNow('yyyy-MM-dd'), util.getNow('yyyy-MM-dd')], // 일별 - 당일
        startDt: '',
        endDt: '',
        axisType: '',
        type: 'smenu',
      }
    },
    // 조회
    search: function () {
      var startDate = ''
      var endDate = ''
      // 년 일때는 설정 안해줌
      if ('DAY' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]
        startDate = this.searchForm.startDt
        endDate = this.searchForm.endDt
      } else if ('MONTH' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]

        const year = this.searchForm.endDt.substring(0, 4)
        const month = this.searchForm.endDt.substring(5, 7)
        const lastDay = new Date(year, month, 0).getDate()

        startDate = this.searchForm.startDt + '-01'
        endDate = this.searchForm.endDt + '-' + lastDay
      } else if ('YEAR' == this.searchForm.dateSearchTpVal) {
        if (util.isEmpty(this.searchForm.startDt) || util.isEmpty(this.searchForm.endDt)) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        startDate = this.searchForm.startDt + '-01-01'
        endDate = this.searchForm.endDt + '-12-31'
      }

      var param = {
        axisType: this.searchForm.dateSearchTpVal,
        startDate: startDate,
        endDate: endDate,
        type: 'smenu',
      }

      this.mainVue.$axios.search(
        this.url,
        param,
        function (result) {
          let statistics = []
          let items = result.items

          let prices = items.map((item) => Number(item['price']))
          let totalPrice = prices.reduce((sum_price, price) => {
            return sum_price + price
          }, 0)
          let counts = items.map((item) => Number(item['count']))
          let totalCount = counts.reduce((sum_count, count) => {
            return sum_count + count
          }, 0)

          this.summaries = ['총 합계', this.formatterNumber(totalPrice), this.formatterNumber(totalCount)]

          this.tableData = items
        }.bind(this),
        false
      )
    },
    getSummaries: function (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '총 합계'
          return
        }

        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => Number.isNaN(value))) {
          const sum = values.reduce((prev, curr) => {
            return prev + curr
          }, 0)
          sums[index] = this.formatterNumber(sum)
        } else {
          sums[index] = '-'
        }
      })
      return sums
    },
    formatterNumber: function (number) {
      return null != number && '' != number ? parseInt(number).toLocaleString() : number
    },
  },
}
</script>
